// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const virtualKeySchema = z.object({
  "id": z.string().uuid(),
  "agent_id": z.string().uuid(),
  "standing_delegation_id": z.string().uuid(),
  "key_prefix": z.string(),
  "allowed_destinations": z.array(z.string()),
  "label": z.string(),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }).nullable(),
  "revoked_at": z.string().datetime({ offset: true }).nullable(),
  "revoked_reason": z.string(),
  "last_used_at": z.string().datetime({ offset: true }).nullable()
}).strict();

export const virtualKeysListResponseSchema = z.object({
  "virtual_keys": z.array(virtualKeySchema)
}).strict();

export const createVirtualKeyResponseSchema = z.object({
  "id": z.string().uuid(),
  "key": z.string(),
  "key_prefix": z.string(),
  "agent_id": z.string().uuid(),
  "allowed_destinations": z.array(z.string()),
  "label": z.string(),
  "expires_at": z.string().datetime({ offset: true }).optional()
}).strict();
